











































































import { Component, Vue } from 'vue-property-decorator';
import '../assets/css/AccountSetup.scss';
import '../assets/css/Common.scss';
import '../assets/css/MainLayout.scss';
import { ObjectFactory } from '@/config/objectFactory';
import { MedTransGoConstants } from '@/util/constants';
import { Document } from '@/types/entity';
import ViewDocumentModal from './modal/ViewDocumentModal.vue';
import UpdateDocumentModal from './modal/UpdateDocumentModal.vue';
import { DateUtils } from '@/util/dateUtils';
import { CommonUtils } from '@/util/commonUtils';

@Component({
    components: {
        ViewDocumentModal,
        UpdateDocumentModal,
    },
    })
export default class UploadRejectedDocument extends Vue {
    private isRejected = false;
    private resourceId: any;
    private showDocumentModal = false;
    private documentName: any;
    private showUpdateDocumentModal = false;
    private transporterId: any;
    private transporterDocuments: Document[] = [];

    private mounted() {
        this.getPartnerProfile();
    }

    private async getPartnerProfile() {
    const partnerService = ObjectFactory.getPartnerService();
    const response = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
    if (response.success && response.data) {
        const partnerProfile = response.data;
        if (partnerProfile.transporterProfile) {
            this.transporterId = partnerProfile.transporterProfile.id;
            const documents: Document[] = [];
            partnerProfile.transporterProfile.documents.forEach((document) => {
                document.status = document.rejected ? 'Rejected' : document.verified ? 'Verified' : 'Not Verified';
                if (document.comments) {
                    document.comments.forEach(async (comment) => {
                        const user = await ObjectFactory.getRequestService().
                        getUserById(comment.addedBy,
                            this.$store.state.serverUrl);
                        if (user.data) {
                            comment.addedBy = user.data.fullname;
                        }
                        comment.addedOn = DateUtils.formatDate(comment.addedOn) as any;
                    });
                }
                if (document.rejected) {
                    documents.push(document);
                    this.isRejected = true;
                }
            });
            this.transporterDocuments = documents;
        }
    }
    }

    private viewDocument(document?: any) {
        this.resourceId = document.resourceId;
        this.showDocumentModal = true;
    }

    private updateTransporterDocuments(document: any) {
        this.documentName = document.name;
        this.showUpdateDocumentModal = true;
    }

    private logout() {
        CommonUtils.logout(this.$store.state);
    }
}
